<template>
  <v-container>
    <v-row no-gutters>
      <v-col xs="12" md="8" offset-md="2">
        <h2 style="color: #084776">Kontakt</h2>
        <div style="font-size: 14px">
        <br>
        <table style="border-collapse: collapse; width: 100%; height: 232px; text-align: center;" border="1">
        <tbody>
        <tr style="height: 21px; ">
        <th style="width: 50%; height: 21px; padding: 10px; text-align: center;">Ime ustanove</th>
        <th style="width: 50%; height: 21px; padding: 10px; text-align: center;">Kontakt osoba</th>
        </tr>
        <tr style="height: 21px;">
        <td style="width: 50%; height: 21px; padding: 10px; text-align: center;"><span style="font-weight: 400;">Agronomski i prehrambeno-tehnolo&scaron;ki fakultet</span></td>
        <td style="width: 50%; height: 21px; padding: 5px; text-align: center;"><span style="font-weight: 400;">Jurica Primorac</span><br><a class="link" href="mailto: jurica.primorac@aptf.sum.ba">jurica.primorac@aptf.sum.ba</a></td>
        
        </tr>
        <tr style="height: 21px;">
        <td style="width: 50%; height: 21px; padding: 10px;text-align: center;"><span style="font-weight: 400;">Akademija likovnih umjetnosti</span></td>
        <td style="width: 50%; height: 21px; padding: 5px; text-align: center;"><span style="font-weight: 400;">Nikol Zadro</span><br><a class="link" href="mailto: nikol.zadro@alu.sum.ba">nikol.zadro@alu.sum.ba</a></td>
        </tr>
        <tr style="height: 21px;">
        <td style="width: 50%; height: 21px; padding: 10px; text-align: center;">Ekonomski fakultet</td>
        <td style="width: 50%; height: 21px; padding: 5px; text-align: center;"><span style="font-weight: 400;">Anela Čolak</span><br><a class="link" href="mailto: anela.colak@ef.sum.ba">anela.colak@ef.sum.ba</a></td>
        </tr>
        <tr style="height: 21px;">
        <td style="width: 50%; height: 21px; padding: 10px; text-align: center;">Fakultet prirodoslovno-<br />matematičkih i odgojnih znanosti</td>
        <td style="width: 50%; height: 21px; padding: 5px; text-align: center;"><span style="font-weight: 400;">Danko Lovrić</span><br><a class="link" href="mailto: danko.lovric@fpmoz.sum.ba">danko.lovric@fpmoz.sum.ba</a></td>
        </tr>
        <tr style="height: 21px;">
        <td style="width: 50%; height: 21px; padding: 10px; text-align: center;">Fakultet strojarstva, računarstva i<br />elektrotehnike</td>
        <td style="width: 50%; height: 21px; padding: 5px; text-align: center;"><span style="font-weight: 400;">Ana Pinjuh</span><br><a class="link" href="mailto: ana.pinjuh@fsre.sum.ba">ana.pinjuh@fsre.sum.ba</a></td>
        </tr>
        <tr style="height: 21px;">
        <td style="width: 50%; height: 21px; padding: 10px; text-align: center;">Fakultet zdravstvenih studija</td>
        <td style="width: 50%; height: 21px; padding: 5px; text-align: center;"><span style="font-weight: 400;">Sanda Mandić</span><br><a class="link" href="mailto: sanda.mandic@fzs.sum.ba">sanda.mandic@fzs.sum.ba</a></td>
        </tr>
        <tr style="height: 21px;">
        <td style="width: 50%; height: 21px; padding: 10px; text-align: center;">Farmaceutski fakultet</td>
        <td style="width: 50%; height: 21px; padding: 5px; text-align: center;"><span style="font-weight: 400;">Franjo Jurilj</span><br><a class="link" href="mailto: franjo.jurilj@farf.sum.ba">franjo.jurilj@farf.sum.ba</a></td>
        </tr>
        <tr style="height: 21px;">
        <td style="width: 50%; height: 21px; padding: 10px; text-align: center;">Filozofski fakultet</td>
        <td style="width: 50%; height: 21px; padding: 5px; text-align: center;"><span style="font-weight: 400;">Krešimir Čavar</span><br><a class="link" href="mailto: kresimir.cavar@ff.sum.ba">kresimir.cavar@ff.sum.ba</a></td>
        </tr>
        <tr>
        <td style="width: 50%; padding: 10px; text-align: center;">Građevinski fakultet</td>
        <td style="width: 50%; padding: 5px; text-align: center;"><span style="font-weight: 400;">Božo Penavić</span><br><a class="link" href="mailto: bozo.penavic@gf.sum.ba">bozo.penavic@gf.sum.ba</a></td>
        </tr>
        <tr>
        <td style="width: 50%; padding: 10px; text-align: center;">Medicinski fakultet</td>
        <td style="width: 50%; padding: 5px; text-align: center;"><span style="font-weight: 400;">Olivera Boras</span><br><a class="link" href="mailto: olivera.boras@mef.sum.ba">olivera.boras@mef.sum.ba</a></td>
        </tr>
        <tr>
        <td style="width: 50%; text-align: center;">Pravni fakultet</td>
        <td style="width: 50%; padding: 5px; text-align: center;"><span style="font-weight: 400;">Ana Dujmović</span><br><a class="link" href="mailto: ana.dujmovic@pf.sum.ba">ana.dujmovic@pf.sum.ba</a></td>
        </tr>
        </tbody>
        </table>
        </div>
        <p class="pt-3">Odaberite pitanje iz padajućeg izbornika. Odgovor sa pripadnim kontakt informacijama pojavit će se u nastavku.</p>
        <v-select
          :items="items"
          item-text="title"
          item-value="value"
          label="Odaberi pitanje"
          color="#084776"
          v-model="selected_question"
          outlined
        ></v-select>
        <div v-for="(item, i) in items" :key="i">
            <div v-if="item.value == selected_question" v-html="item.text"></div>
        </div>
        
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    watch: {
      selected_question: function() {
        this.items(this.selected_question);
      }
    },

    // computed: {

    //   selectedItem() {
    //     return this.studiji.find(item => {
    //       return item.id === this.selected_studiy;
    //     });
    //   }
    // },
    selected_question: null,
    items: [
      {
        value: 0,
        title: "Zaboravio sam lozinku",
        text: 'Žao nam je što ste zaboravili vašu lozinku, no upravljanje korisničkim računom obavlja matična ustanova koja ga vam je izdala. Molimo, kontaktirajte informatičku službu matične ustanove koja vam je inicijalno izdala korisnički račun.'
      },
      {
        value: 1,
        title: "Potreban mi je eduroam korisnički račun",
        text: 'eduroam usluga na Sveučilištu u Mostaru koristi AAI@SUM elektroničke identitete. AAI@SUM identitete izdaju davatelji identiteta. Molimo, kontaktirajte informatičku službu svoje matične ustanove kako biste dobili dodatne informacije o izdavanju AAI@SUM identiteta.'
      },
      {
        value: 2,
        title: "Možete li mi pomoći sa podešavanje uređaja za pristup eduroamu?",
        text: 'Alat <a href="https://installer.eduroam.hr/HomeOrg/sum.ba/" target="_blank" class="link">eduroam installer</a> razvijen je kako bi se krajnjim korisnicima omogućilo jednostavno i sigurno konfiguriranja korisničkih uređaja za spajanje na eduroam. Usluga eduroam koncipirana je tako da administratori matičnih ustanova održavaju poslužitelje koji se koriste pri autentikaciji korisnika, čiji je elektronički identitet izdala ta matična ustanova. Samim time, korisnici koji imaju problema pri korištenju eduroam usluge trebaju se obratiti za pomoć administratoru ustanove koja im je izdala elektronički identitet. Ako je potrebno vaš administrator kontaktirat će tim SUMIT-a za pomoć pri uklanjanju problema.'
      },
      {
        value: 3,
        title: "Zašto moja ustanova ne pruža eduroam uslugu?",
        text: 'Ukoliko vaša matična ustanova ne pruža eduroam uslugu, uputite informatičku službu na upute dane na <a href="/davatelji_usluga" class="link">stranicama za davatelje usluge</a>.'
      },
      {
        value: 4,
        title: "Moja organizacija bi se željela priključiti na eduroam uslugu",
        text: 'Ukoliko nakon čitanja uputa <a href="/davatelji_usluga" class="link">za davatelje usluge</a> imate dodatnih pitanje, kontaktirajte nas na sljedeću e-mail adresu: <a href="mailto:eduroam@sum.ba" class="link">eduroam@sum.ba</a>'
      },
      {
        value: 5,
        title: "Kako uvesti eduroam uslugu?",
        text: 'Ukoliko nakon čitanja uputa <a href="/davatelji_usluga" class="link">za davatelje usluge</a> imate dodatnih pitanje, kontaktirajte nas na sljedeću e-mail adresu: <a href="mailto:eduroam@sum.ba" class="link">eduroam@sum.ba</a>'
      },
      {
        value: 6,
        title: "Povratne informacije o webstranici",
        text: 'Ukoliko imate prijedloge ili pritužbe vezene uz ove web stranice, kontaktirajte nas na sljedeću e-mail adresu: <a href="mailto:eduroam@sum.ba" class="link">eduroam@sum.ba</a>'
      }
    ]
  })
};
</script>